export class State {
  error: Record<string, any> = {};
  success: Record<string, any> = {};
  isLoading = false;
  dataList: Array<any> = [];
  dataItem: Record<string, any> = {};
  total = 0;
}
